module.exports = __webpack_public_path__ + "img/appmalf-sdk.2f03d0c.png";